import { Error404, NoAvailableCountryMarket } from '../components/ErrorPages';
import { Account } from '../features/Account';
import { Briefing } from '../features/Briefing';
import { StepSuccess } from '../features/Briefing/StepSuccess';
import { BriefingSelection } from '../features/BriefingSelection';
import { ChooseCountryMarket } from '../features/ChooseCountryMarket';
import { Intro } from '../features/Intro';
import { ProjectOverview } from '../features/ProjectOverview';
import { ProjectDetails } from '../features/ProjectOverview/ProjectDetails';
import { OauthHandler } from '../features/SignIn';
import AppLayout from '../layouts/AppLayout';
import AuthLayout from '../layouts/AuthLayout';

export const routes = [
  {
    path: '/',
    element: <AppLayout />,
    children: [
      {
        index: true,
        element: <Intro />,
      },
      {
        path: '/choose-country-market/:reason',
        element: <AuthLayout />,
        children: [
          {
            index: true,
            element: <ChooseCountryMarket />,
          },
        ],
      },
      {
        path: '/:country/:market',
        element: <AuthLayout />,
        children: [
          {
            index: true,
            element: <Intro />,
          },
          {
            path: '/:country/:market/start',
            element: <BriefingSelection />,
            basePath: {
              name: 'briefingSelection',
              path: '/start',
            },
          },
          {
            path: '/:country/:market/success',
            element: <StepSuccess />,
            basePath: {
              name: 'stepSuccess',
              path: '/success',
            },
          },
          {
            path: '/:country/:market/briefing/:branch/:step',
            element: <Briefing />,
            basePath: {
              name: 'briefing',
              path: '/briefing',
            },
          },
          {
            path: '/:country/:market/project-overview',
            element: <ProjectOverview />,
            basePath: {
              name: 'projectOverview',
              path: '/project-overview',
            },
          },
          {
            path: '/:country/:market/project-overview/:briefingKey',
            element: <ProjectDetails />,
          },
          {
            path: '/:country/:market/account',
            element: <Account />,
            basePath: {
              name: 'account',
              path: '/account',
            },
          },
        ],
      },
      {
        path: '/oauth-handler',
        element: <OauthHandler />,
        basePath: {
          name: 'oauthHandler',
          path: '/oauth-handler',
        },
      },
      {
        path: '/no-available-country-market',
        element: <NoAvailableCountryMarket />,
      },
      {
        path: '*',
        element: <Error404 />,
      },
    ],
  },
];
